// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n#display {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #186966;\r\n}\r\n\r\n#muteToggle {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    font-size: 2rem;\r\n    background-color: transparent;\r\n    border: none;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
